import Form from './form';

const sessionStorageKey = 'tradera.signup.form';

export default class LocalFormStore {
    constructor() {
        this.saveState = this.saveState.bind(this);
        this.restoreState = this.restoreState.bind(this);
    }

    saveState(form, field) {
        try {
            this._initializeState();
            if (this._get(field) !== (form.get(field) || '')) {
                this.state.fields[field] = form.get(field);
                this.state.dateSaved = Date.now();
                sessionStorage.setItem(
                    sessionStorageKey,
                    JSON.stringify(this.state)
                );
            }
        } catch (err) {
            // do nothing
        }
    }

    restoreState(form = new Form()) {
        try {
            this._initializeState();
            if (!this._checkStateExpirationTime()) {
                this.clear();
                return;
            }
            Object.keys(this.state.fields).forEach((field) => {
                const value = this._get(field);
                form.setFromGenerated(field, value);
            });
        } catch (err) {
            // do nothing
        }
    }

    clear() {
        try {
            sessionStorage.removeItem(sessionStorageKey);
            this.state = null;
        } catch (err) {
            // do nothing
        }
    }

    _get(field) {
        return this.state.fields[field] || '';
    }

    _initializeState() {
        if (this.state) {
            return;
        }
        const storedState = sessionStorage.getItem(sessionStorageKey);
        if (storedState) {
            this.state = JSON.parse(storedState);
        } else {
            this.state = { fields: {} };
        }
    }

    _checkStateExpirationTime() {
        var storedDate = this.state.dateSaved;
        var diff = storedDate ? (Date.now() - storedDate) / 1000 : 61;
        return diff < 60 ? true : false;
    }
}
